import axios from "axios";

// const API_BASE_URL = "http://localhost:8071";
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
	//get tenant info
	getTenant(subdomain) {
		return axios
			.get(`${API_BASE_URL}/organizations/${subdomain}/info`)
			.then((r) => r.data);
	},

	searchEvents(eventSearchInfo, additionalParams = {}) {
		return axios
			.post(
				`${API_BASE_URL}/event`,
				{
					keyword: eventSearchInfo, // Assuming eventSearchInfo is the search term or event name
					...additionalParams,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				throw error;
			});
	},
	searchEventsByLocationAndRadius(eventSearchInfo) {
		return axios
			.post(
				`${API_BASE_URL}/events/nearby`,
				{
					latitude: eventSearchInfo.latitude,
					longitude: eventSearchInfo.longitude,
					radius: eventSearchInfo.radius, // Radius in meters
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				throw error;
			});
	},
	getEventDetails(id) {
		return axios.get(`${API_BASE_URL}/events/${id}`);
	},
	getEvents() {
		return axios.get(`${API_BASE_URL}/events`);
	},

	// attendee routes
	emailVerification(emailToVerify) {
		return axios
			.post(`${API_BASE_URL}/verify-email`, { email: emailToVerify })
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	// send otp
	sendOtp(email) {
		return axios
			.post(`${API_BASE_URL}/send-otp`, { email })
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	// verifyOtp
	verifyOtp(email, otp) {
		return axios
			.post(
				`${API_BASE_URL}/verify-otp`,
				{ email, otp },
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},

	// add booking methods
	// Add booking method to handle ticket registration
	bookEvent(attendeeData, ticketData, paymentData) {
		return axios
			.post(
				`${API_BASE_URL}/events/register`, // Assuming you have a POST endpoint for booking
				{
					Attendee: attendeeData,
					Ticket: ticketData,
					Payment: paymentData,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	checkTicketStatus(pi) {
		return axios
			.post(
				`${API_BASE_URL}/event/check-ticket-status`,
				{
					payment_intent_id: pi,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	// cancel payment intent
	cancelPaymentIntent(pi) {
		return axios
			.post(
				`${API_BASE_URL}/payment-intent/cancel`,
				{
					intent_id: pi,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	//checking ticket exist
	checkTicketExist(userData, eventData) {
		return axios
			.post(
				`${API_BASE_URL}/check/ticket-exist/user`,
				{
					email: userData,
					event_id: eventData,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
					validateStatus: function (status) {
						// Accept 302 as valid response
						return status === 200 || status === 302;
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	musicRecommandation(musicName) {
		return axios
			.post(
				`${API_BASE_URL}/music/recommendations`,
				{
					keyword: musicName,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
					validateStatus: function (status) {
						// Accept 302 as valid response
						return status === 200 || status === 302;
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	musicSuggestion(eventId, userData, songId) {
		return axios
			.post(
				`${API_BASE_URL}/events/${eventId}/music-suggestions`,
				{
					email: userData,
					songId: songId,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
					validateStatus: function (status) {
						// Accept 302 as valid response
						return status === 200 || status === 302;
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	// Unsbuscribe from event
	unsubscribeNewsLetter(email) {
		return axios
			.put(
				`${API_BASE_URL}/newsletter/unsubscribe`,
				{
					email: email,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
	getCategories() {
		return axios
			.get(`${API_BASE_URL}/categories`)
			.then((response) => response.data)
			.catch((error) => {
				return Promise.reject(error);
			});
	},
};
